import React, { createContext, useState } from 'react';
import { FormInstance } from 'antd';
import { DefaultServices } from '../../../../../hooks/api/services';
import { SimpleProviderProps } from '../../../../../types';

export interface ServicesContextProps {
  initialState: DefaultServices | null,
  setInitialState: (data: DefaultServices) => void,
  form: FormInstance | null;
  setForm: (form: FormInstance) => void;
  isValid: boolean;
  setValid: (value: boolean) => void;
}

const defaultValue = {
  initialState: null,
  setInitialState: (data: DefaultServices) => {
    // default
  },
  form: null,
  setForm: () => {
    // default
  },
  isValid: false,
  setValid: (value: boolean) => {
    // default
  },
};

export const DefaultServicesContext = createContext<ServicesContextProps>(defaultValue);

function ServicesProvider({
  children,
}: SimpleProviderProps) {
  const [initialState, setInitialState] = useState<DefaultServices | null>(null);
  const [form, setForm] = useState<FormInstance | null>(null);
  const [isValid, setValid] = useState<boolean>(false);

  return (
    <DefaultServicesContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        initialState,
        setInitialState,
        form,
        setForm,
        isValid,
        setValid,
      }}
    >
      {children}
    </DefaultServicesContext.Provider>
  );
}

export default ServicesProvider;

export const useServicesContext = ():
ServicesContextProps => React.useContext(DefaultServicesContext);
